import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('ja-screen')
export class JAScreen extends LitElement {
  static styles = css`
    :host {
      /* Establishes absolute independent alignment boundaries */
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;

      /* Apply background color from CSS custom property */
      background-color: var(--screen-background-color, #121212);

      /* Enforces custom independent momentum scroll layers */
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;

      /* Hardware acceleration flags: prepares layer hooks for GPU rendering */
      will-change: transform, opacity;
      backface-visibility: hidden;
      transform: translate3d(0, 0, 0);

      /* Setup base transition curves */
      transition:
        transform var(--transition-duration) var(--transition-timing),
        opacity var(--transition-duration) var(--transition-timing);
    }
    /* Reset default cross-fade animation duration */
    ::view-transition-old(root),
    ::view-transition-new(root) {
      animation-duration: var(--transition-duration, 280ms);
      animation-timing-function: var(--transition-timing, cubic-bezier(0.4, 0, 0.2, 1));
      animation-fill-mode: both;
    }

    /* ==========================================
      FORWARD TRANSITION (Push Left)
      ========================================== */
    [data-transition-direction="forward"]::view-transition-old(root) {
      animation-name: slide-out-left;
    }
    [data-transition-direction="forward"]::view-transition-new(root) {
      animation-name: slide-in-right;
    }

    /* ==========================================
      BACKWARD TRANSITION (Pop Right)
      ========================================== */
    [data-transition-direction="backward"]::view-transition-old(root) {
      animation-name: slide-out-right;
    }
    [data-transition-direction="backward"]::view-transition-new(root) {
      animation-name: slide-in-left;
    }

    /* ==========================================
      KEYFRAME DEFINITIONS (Transforms Only!)
      ========================================== */
    @keyframes slide-in-right {
      from { transform: translate3d(100%, 0, 0); }
      to { transform: translate3d(0, 0, 0); }
    }
    @keyframes slide-out-left {
      from { transform: translate3d(0, 0, 0); opacity: 1; }
      to { transform: translate3d(-30%, 0, 0); opacity: 0.6; }
    }
    @keyframes slide-in-left {
      from { transform: translate3d(-30%, 0, 0); opacity: 0.6; }
      to { transform: translate3d(0, 0, 0); opacity: 1; }
    }
    @keyframes slide-out-right {
      from { transform: translate3d(0, 0, 0); }
      to { transform: translate3d(100%, 0, 0); }
    }

    .scroll-content {
      padding: 20px;
      padding-bottom: 80px; /* Safe padding workspace boundary */
    }

    @media (prefers-reduced-motion: reduce) {
      :host {
        transition: none !important;
        transform: none !important;
      }
    }
  `;

  render() {
    return html`
      <div class="scroll-content">
        <slot></slot>
      </div>
    `;
  }
}
